export const getUserFromStorage = () => {
    try {
        const userData = localStorage.getItem('USUARIO_TIENDA_ONLINE');
        if (!userData) return {};

        let parsed;
        try {
            parsed = JSON.parse(userData);
        } catch (parseError) {
            console.error('Error parsing JSON from localStorage:', parseError);
            return null;
        }

        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed; // Devuelve el objeto si es válido

        console.warn('Unexpected user format:', parsed);
        return {}; // Fallback para formatos no válidos
    } catch (error) {
        console.error('Error reading user from localStorage:', error);
        return null;
    }
};

export const saveUserToStorage = (user) => {
    try {
        // Asegurar que es un objeto de clave-valor
        const userObject = typeof user === 'object' && !Array.isArray(user) ? user : {};

        localStorage.setItem('USUARIO_TIENDA_ONLINE', JSON.stringify(userObject));
    } catch (error) {
        console.error('Error saving user to localStorage:', error);
    }
};

export const clearUserFromStorage = () => {
    try {
        localStorage.removeItem('USUARIO_TIENDA_ONLINE');
    } catch (error) {
        console.error('Error clearing user from localStorage:', error);
    }
}